var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-inputs search-input"},[_c('vs-input',{attrs:{"label-placeholder":"Buscar por algo..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }